export default class RowItem {
  constructor(row) {
    this.cellItems = [];
    this.Row = row;
  }
}
